import React from 'react'

import { motion } from "framer-motion";

import "../css/PageTransition.css"

const PageTransition = () => {
    
    const anim = (variants, custom) => {
        return {
            initial: "initial",
            animate: "enter",
            exit: "exit",
            variants,
            custom
        }
    }
    const expand = {
        initial: {
            top: 0
        },
        enter: (i) => ({
            top: "100vh",
            transition: {
                duration: 1,
                delay: 0.17 * i,
                ease: [0.215, 0.61, 0.355, 1],
            },
            transitionEnd: { height: "0", top: "0" }
        }),
        exit: (i) => ({
            height: "100vh",
            transition: {
                duration: 1,
                delay: 0.17 * i,
                ease: [0.215, 0.61, 0.355, 1]
            }
        })

    }

    const opacity = {
        initial: {
            opacity: 0.5
        },
        enter: {
            opacity: 0
        },
        exit: {
            opacity: 0.5,
        }
    }

    const nbofColumns = 5;

    return (
        <div className="page stairs">
            <motion.div {...anim(opacity)} className='transition-background' />
            <div className='transition-container'>
                {
                    [...Array(nbofColumns)].map((_, i) => {
                        return <motion.div className='transition-div' {...anim(expand, nbofColumns - i)} key={i} />
                    })
                }
            </div>
        </div>
    )
}

export default PageTransition